import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User } from '@fellowship/shared'

interface AuthState {
  user: User | null
  accessToken: string | null
  refreshToken: string | null
  /** True once the user has set a location (completed onboarding step 1) */
  onboardingComplete: boolean

  setTokens: (accessToken: string, refreshToken: string, user: unknown) => void
  setUser: (user: User) => void
  setOnboardingComplete: () => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      onboardingComplete: false,

      setTokens: (accessToken, refreshToken, user) =>
        set({ accessToken, refreshToken, user: user as User }),

      setUser: (user) => set({ user }),

      setOnboardingComplete: () => set({ onboardingComplete: true }),

      clearAuth: () =>
        set({ user: null, accessToken: null, refreshToken: null, onboardingComplete: false }),
    }),
    { name: 'fellowship-auth' },
  ),
)
